import React, { useState, useEffect } from "react";
import { Modal, CircularProgress, Typography, Slider } from "@mui/material";
import Table from "@mui/material/Table";
import html2canvas from "html2canvas";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Button, TextField } from "@mui/material";
import ModelRankingTable from './ModelRankingTable';

import {
    ResponsiveContainer,
    LineChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Line,
    Brush,
    ReferenceLine
} from "recharts";

import "./leftbar.css";

import { format, set } from "date-fns";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";


const Forecastlog = ({
    selectedMarker,
    setIsFcModalOpen,
    setIsMultiColFcModalOpen,
    HelpModal,
    datalogs,
    imdatalogs,
    setimDatalogs,
    formatDate,
    helpOpen,
    setHelpOpen,
    handleCloseFcModal,
}) => {
    const chartRef = React.useRef();
    const handleDownload = () => {
        if (chartRef.current) {
            html2canvas(chartRef.current).then((canvas) => {
                const link = document.createElement("a");
                link.download = "ForecastingLog.png";
                link.href = canvas.toDataURL();
                link.click();
            });
        }
    };
    const [zoomLevelImDatalogs, setZoomLevelImDatalogs] = useState(0);
    const [startIndexImDatalogs, setStartIndexImDatalogs] = useState(0);
    const [endIndexImDatalogs, setEndIndexImDatalogs] = useState(
        imdatalogs.length - 1
    );

    useEffect(() => {
        setStartIndexImDatalogs(0);
        setEndIndexImDatalogs(imdatalogs.length - 1);
    }, [imdatalogs]); // Ensures indices update when new data comes in


    const handleZoomImDatalogs = (event, newValue) => {
        setZoomLevelImDatalogs(newValue);
        const range = imdatalogs.length;
        const zoomFactor = newValue / 100;

        const newStart = Math.floor(range * zoomFactor * 0.5);
        const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

        setStartIndexImDatalogs(Math.max(0, newStart));
        setEndIndexImDatalogs(Math.min(imdatalogs.length - 1, newEnd));
    };

    const handleZoomInImDatalogs = () =>
        setZoomLevelImDatalogs((prev) => Math.min(prev + 10, 100));
    const handleZoomOutImDatalogs = () =>
        setZoomLevelImDatalogs((prev) => Math.max(prev - 10, 0));
    const resetZoomImDatalogs = () => {
        setStartIndexImDatalogs(0);
        setZoomLevelImDatalogs(0);
        setEndIndexImDatalogs(imdatalogs.length - 1);
    };
    const handleSort = (key) => {
        const newDirection = sortConfig[key].direction === "asc" ? "desc" : "asc";
        setSortConfig({
            ...sortConfig,
            [key]: { direction: newDirection },
        });
    };

    // Visible Data Calculation

    const visibleDataImDatalogs = imdatalogs.slice(
        startIndexImDatalogs,
        endIndexImDatalogs + 1
    );

    const [selectedMetric, setSelectedMetric] = useState("wtr"); // Default to Water Level

    const [dataLimitImDatalogs, setDataLimitImDatalogs] = useState(
        visibleDataImDatalogs.length
    ); // Default to all data

    // Apply the data limit to the visible data

    const handleDataLimitChangeImDatalogs = (event) => {
        setDataLimitImDatalogs(parseInt(event.target.value));
    };

    // Apply the data limit to the visible data
    const filteredDataImDatalogs = visibleDataImDatalogs.slice(
        -dataLimitImDatalogs
    );


    const [sortConfig, setSortConfig] = useState({
        mTm: { direction: "asc" },
        wtr: { direction: "asc" },
    });

    // State for model weights
    const [weights, setWeights] = useState({
        period: 6,
        weight_lstm: 1,
        weight_bilstm: 1,
        weight_arima: 1,
        weight_sarima: 1,
    });

    // Data preference state - NEW
    const [dataPreference, setDataPreference] = useState("imputation");

    const handleDataPreferenceChange = (event) => {
        setDataPreference(event.target.value);
    };

    const [missingDataRate, setMissingDataRate] = useState(null);
    const [showMissingRate, setShowMissingRate] = useState(false);

    const fetchMissingDataRate = async () => {
        if (!selectedMarker || !startDate || !endDate) {
            alert("Please specify both start and end dates");
            return;
        }

        if (startDate > endDate) {
            alert("Start date cannot be after end date");
            return;
        }

        // setIsLoading(true);

        try {
            const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/missing-data-rate/${selectedMarker.wellId}/${startDate}/${endDate}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`);
            }

            const data = await response.json();
            console.log("Missing data rate response:", data);

            setMissingDataRate(data.missingRate);
            setShowMissingRate(true);

        } catch (error) {
            console.error("Error fetching missing data rate:", error);
            alert(`Failed to fetch missing data rate: ${error.message}`);
        } finally {
            // setIsLoading(false);
        }
    };

    const [originalData, setoriginalData] = useState(null);

    const [earliestDate, setEarliestDate] = useState("");
    const [latestDate, setLatestDate] = useState("");

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isForecasted, setIsForecasted] = useState(false);

    const handleStartDateChange = (event) => {
        setIsForecasted(false);
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setIsForecasted(false);
        setEndDate(event.target.value);
    };

    useEffect(() => {
        const fetchDateRange = async () => {
            try {
                const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}/date-range`);
                const data = await response.json();

                if (response.ok) {
                    setEarliestDate(data.earliest);
                    setLatestDate(data.latest);

                    // Set default dates if not already set
                    if (!startDate) {
                        setStartDate(new Date(data.earliest).toISOString().split('T')[0]);
                    }
                    if (!endDate) {
                        setEndDate(new Date(data.latest).toISOString().split('T')[0]);
                    }
                } else {
                    console.error(data.message || "Failed to fetch date range.");
                }
            } catch (err) {
                console.error("Error fetching date range:", err);
            }
        };

        if (selectedMarker && selectedMarker.wellId) {
            fetchDateRange();
            fetchVersions(selectedMarker.wellId);
        }
    }, [selectedMarker]);

    const [versions, setVersions] = useState([]); // Store versions data from backend
    const [selectedVersion, setSelectedVersion] = useState(0); // Selected version number
    const [versionsanom, setVersionsanom] = useState([]); // Store anomaly versions data from backend
    const [selectedVersionAnom, setSelectedVersionAnom] = useState("0"); // Selected anomaly version number
    const [tableData, setTableData] = useState([]); // Store the fetched data for the selected version

    // State to store modal open state and version details
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [versionDetails, setVersionDetails] = useState(null);

    // Fetch versions based on selected wellId
    const fetchVersions = async (wellId) => {
        try {
            const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs_versions/${wellId}`);
            const data = await response.json();

            if (response.ok) {
                const impData = data.filter(item => item.imp_or_anom === 'imp');
                const anomData = data.filter(item => item.imp_or_anom === 'anom');

                setVersions(impData);
                setVersionsanom(anomData);
            } else {
                console.error("Error fetching versions:", data.error);
            }
        } catch (error) {
            console.error("Error fetching versions:", error);
        }
    };

    const fetchVersionDetails = async () => {
        try {
            // Call the API to get the version details (here version 0 means the latest)
            const response = await fetch(
                `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersion}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "imp_or_anom": "imp", // custom header
                    },
                }
            );
            const data = await response.json();

            if (response.ok) {
                setVersionDetails(data); // Store the received data in state
                setIsModalOpen(true); // Open the modal
            } else {
                console.error("Error fetching version details:", data.error);
            }
        } catch (error) {
            console.error("Error fetching data from backend:", error);
        }
    };

    // Handle version change in dropdown
    const handleVersionChange = async (event) => {
        const versionNumber = event ? event.target.value : 0;
        setSelectedVersion(versionNumber); // Update selected version number

        try {
            if (versionNumber === 0) {
                // Fetch original data when version 0 is selected
                const response = await fetch(
                    `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}`
                );
                const data = await response.json();
                if (response.ok) {
                    setTableData(data);
                    setimDatalogs(data);
                    resetZoomImDatalogs();
                    setDataLimitImDatalogs(data.length);
                    setIsForecasted(false);
                }
            } else {
                const response = await fetch(
                    `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
                );
                const data = await response.json();

                if (response.ok) {
                    setTableData(data);
                    setimDatalogs(data);
                    resetZoomImDatalogs();
                    setDataLimitImDatalogs(data.length);
                    setIsForecasted(false);
                } else {
                    console.error("Error fetching imputed data:", data.error);
                    alert("Error fetching data for this version");
                }
            }
        } catch (error) {
            console.error("Error fetching imputed data:", error);
            alert("Failed to fetch data for this version");
        }
    };

    // State for confirmation dialogs
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmDialogMessage, setConfirmDialogMessage] = useState("");
    const [confirmDialogAction, setConfirmDialogAction] = useState(null);

    // Show confirmation dialog
    const showConfirmDialog = (message, action) => {
        setConfirmDialogMessage(message);
        setConfirmDialogAction(() => action);
        setConfirmDialogOpen(true);
    };

    // Handle confirmation dialog confirm
    const handleConfirmDialogConfirm = () => {
        if (confirmDialogAction) {
            confirmDialogAction();
        }
        setConfirmDialogOpen(false);
    };

    // Handle confirmation dialog cancel
    const handleConfirmDialogCancel = () => {
        setConfirmDialogOpen(false);
    };

    // Clear imputation version (reset to raw data)
    const handleClearImputationVersion = async () => {
        if (!selectedVersion || selectedVersion === 0) {
            alert("Already using raw data (no imputation version selected)");
            return;
        }

        showConfirmDialog(
            `Are you sure you want to reset to raw data? This will clear the imputation version from view.`,
            async () => {
                try {
                    setSelectedVersion(0);

                    // Fetch raw data
                    const response = await fetch(
                        `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}`
                    );

                    if (response.ok) {
                        const rawData = await response.json();
                        setTableData(rawData);
                        setimDatalogs(rawData);
                        resetZoomImDatalogs();
                        setDataLimitImDatalogs(rawData.length);
                        setIsForecasted(false);

                        alert("Successfully reset to raw data (imputation cleared)");
                    } else {
                        const errorData = await response.json();
                        alert(`Failed to reset to raw data: ${errorData.error}`);
                    }
                } catch (error) {
                    console.error("Error resetting to raw data:", error);
                    alert(`Failed to reset to raw data: ${error.message}`);
                }
            }
        );
    };

    // Clear anomaly correction version (reset to raw data)
    const handleClearAnomalyVersion = async () => {
        if (!selectedVersionAnom || selectedVersionAnom === "0") {
            alert("Already using raw data (no anomaly correction version selected)");
            return;
        }

        showConfirmDialog(
            `Are you sure you want to reset to raw data? This will clear the anomaly correction version from view.`,
            async () => {
                try {
                    setSelectedVersionAnom("0");

                    // Fetch raw data
                    const response = await fetch(
                        `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}`
                    );

                    if (response.ok) {
                        const rawData = await response.json();
                        setTableData(rawData);
                        setimDatalogs(rawData);
                        resetZoomImDatalogs();
                        setDataLimitImDatalogs(rawData.length);
                        setIsForecasted(false);

                        alert("Successfully reset to raw data (anomaly correction cleared)");
                    } else {
                        const errorData = await response.json();
                        alert(`Failed to reset to raw data: ${errorData.error}`);
                    }
                } catch (error) {
                    console.error("Error resetting to raw data:", error);
                    alert(`Failed to reset to raw data: ${error.message}`);
                }
            }
        );
    };


    const handleMultiColForecast = () => {
    
        setIsFcModalOpen(false);
        setIsMultiColFcModalOpen(true)
                
    };

    const handleDetailsButtonClick = () => {
        if (selectedVersion) {
            fetchVersionDetails(selectedMarker.wellId, selectedVersion); // Fetch details for the selected version
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false); // Close the modal
    };

    const handleVersionChangeAnom = async (event) => {
        const versionNumber = event ? event.target.value : "0";
        setSelectedVersionAnom(versionNumber);

        try {
            if (versionNumber === "0") {
                // Fetch original data when version 0 is selected
                const response = await fetch(
                    `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}`
                );
                const data = await response.json();
                if (response.ok) {
                    setTableData(data);
                    setimDatalogs(data);
                    resetZoomImDatalogs();
                    setDataLimitImDatalogs(data.length);
                    setIsForecasted(false);
                }
            } else {
                // Fetching version-specific data
                const response = await fetch(
                    `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
                );
                const data = await response.json();

                if (response.ok) {
                    setTableData(data);
                    setimDatalogs(data);
                    resetZoomImDatalogs();
                    setDataLimitImDatalogs(data.length);
                    setIsForecasted(false); // Reset forecasting state
                } else {
                    console.error("Error fetching anomaly corrected data:", data.error);
                    alert("Error fetching data for this version");
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("Failed to fetch data for this version");
        }
    };

    // function to fetch anomaly version details
    const fetchVersionDetailsAnom = async () => {
        try {
            const response = await fetch(
                `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersionAnom}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'imp_or_anom': 'anom'
                    }
                }
            );
            const data = await response.json();

            if (response.ok) {
                setVersionDetails(data);
                setIsModalOpen(true);
            } else {
                console.error("Error fetching anomaly version details:", data.error);
            }
        } catch (error) {
            console.error("Error fetching anomaly data from backend:", error);
        }
    };

    // function to handle details button click for anomaly versions
    const handleDetailsButtonClickAnom = () => {
        if (selectedVersionAnom) {
            fetchVersionDetailsAnom();
        }
    };

    // Function to merge data based on user preferences
    const mergeDataBasedOnPreferences = async () => {
        try {
            // setIsLoading(true);

            // First get the raw data
            const rawResponse = await fetch(
                `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}`
            );
            const rawData = await rawResponse.json();

            if (!rawResponse.ok) {
                throw new Error("Failed to fetch raw data");
            }

            // Set up arrays for the imputation and anomaly data
            let imputationData = [];
            let anomalyData = [];

            // If an imputation version is selected, get that data
            if (selectedVersion !== 0) {
                const impResponse = await fetch(
                    `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${selectedMarker.wellId}/${selectedVersion}`
                );
                if (impResponse.ok) {
                    imputationData = await impResponse.json();
                }
            }

            // If an anomaly version is selected, get that data
            if (selectedVersionAnom !== "0") {
                const anomResponse = await fetch(
                    `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${selectedVersionAnom}`
                );
                if (anomResponse.ok) {
                    anomalyData = await anomResponse.json();
                }
            }

            // Create maps for faster lookup
            const rawMap = new Map();
            rawData.forEach(item => {
                rawMap.set(item.mTm, item);
            });

            const impMap = new Map();
            imputationData.forEach(item => {
                if (item.is_imputed) {
                    impMap.set(item.mTm, item);
                }
            });

            const anomMap = new Map();
            anomalyData.forEach(item => {
                if (item.is_anomaly_corrected) {
                    anomMap.set(item.mTm, item);
                }
            });

            // Merge based on preference
            let mergedData = [...rawData]; // Start with raw data

            // Apply preference logic
            if (dataPreference === "imputation") {
                // Imputation takes precedence over anomaly
                mergedData = mergedData.map(item => {
                    // First apply anomaly correction if available
                    const anomItem = anomMap.get(item.mTm);
                    if (anomItem) {
                        item = { ...item, ...anomItem };
                    }

                    // Then override with imputation if available (higher precedence)
                    const impItem = impMap.get(item.mTm);
                    if (impItem) {
                        item = { ...item, ...impItem };
                    }

                    return item;
                });
            } else {
                // Anomaly correction takes precedence over imputation
                mergedData = mergedData.map(item => {
                    // First apply imputation if available
                    const impItem = impMap.get(item.mTm);
                    if (impItem) {
                        item = { ...item, ...impItem };
                    }

                    // Then override with anomaly correction if available (higher precedence)
                    const anomItem = anomMap.get(item.mTm);
                    if (anomItem) {
                        item = { ...item, ...anomItem };
                    }

                    return item;
                });
            }

            // Sort by measurement time
            mergedData.sort((a, b) => new Date(a.mTm) - new Date(b.mTm));

            // Filter by date range if specified
            if (startDate && endDate) {
                const start = new Date(startDate);
                const end = new Date(endDate);
                mergedData = mergedData.filter(item => {
                    const date = new Date(item.mTm);
                    return date >= start && date <= end;
                });
            }

            setimDatalogs(mergedData);
            setTableData(mergedData);
            resetZoomImDatalogs();
            setDataLimitImDatalogs(mergedData.length);
            setIsForecasted(false);

            return mergedData;
        } catch (error) {
            console.error("Error merging data:", error);
            alert(`Failed to merge data: ${error.message}`);
            return [];
        } finally {
            // setIsLoading(false);
        }
    };

    // Custom Dot Component
    const CustomDot = (dataKey) => (props) => {
        const { cx, cy, payload } = props;

        // Need additional check for undefined values to avoid render errors
        if (!cx || !cy || !payload) return null;

        const pointDate = new Date(payload.mTm);
        const cutoffDate = endDate ? new Date(endDate) : null;

        if (payload.is_imputed) {
            return (
                <circle cx={cx} cy={cy} r={3} stroke="red" strokeWidth={2} fill="red" />
            );
        }

        if (payload.is_anomaly_corrected) {
            return (
                <circle cx={cx} cy={cy} r={3} stroke="pink" strokeWidth={2} fill="pink" />
            );
        }

        // Show orange dot only for forecasted_wtr after endDate
        if (isForecasted && dataKey === 'forecasted_wtr' && cutoffDate && pointDate > cutoffDate) {
            return (
                <circle cx={cx} cy={cy} r={4} stroke="orange" strokeWidth={2} fill="orange" />
            );
        }

        if (isForecasted && dataKey === 'wtr' && cutoffDate && pointDate > cutoffDate) {
            return (
                <circle cx={cx} cy={cy} r={2} stroke="black" strokeWidth={1} fill="black" />
            );
        }

        if (dataKey === 'wtr')
            return <circle cx={cx} cy={cy} r={3} fill="black" />;

        return null;
    };


    const handleWeightChange = (event) => {
        const { name, value } = event.target;
        if (isNaN(value)) {
            alert("Please enter a numerical value");
            return;
        }
        setWeights((prevWeights) => ({
            ...prevWeights,
            [name]: value,
        }));
    };

    const [progress, setProgress] = useState(0);

    const [Rate, setRate] = useState("");
    const handleRateChange = (event) => {
        setRate(event.target.value);
    };

    const [option, setOption] = useState("overall"); // Initialize with the string "overall"

    const handleOption = (event, newOption) => {
        if (newOption !== null) {
            setOption(newOption);
        }
    };

    const handleClear = () => {
        setRate("");
        setOption("overall");
        setWeights({
            period: 6,
            weight_lstm: 1,
            weight_bilstm: 1,
            weight_arima: 1,
            weight_sarima: 1,
        });
    };


    const sortedImDatalogs = [...imdatalogs].sort((a, b) => {
        const key = Object.keys(sortConfig).find(
            (k) => sortConfig[k].direction !== "asc"
        );
        if (!key) return 0;
        const direction = sortConfig[key].direction === "asc" ? 1 : -1;
        if (a[key] < b[key]) return -1 * direction;
        if (a[key] > b[key]) return 1 * direction;
        return 0;
    });


    const imdownloadAsCSV = () => {
        const csv = Papa.unparse(imdatalogs);
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        saveAs(blob, "datalogs.csv");
    };

    const imdownloadAsPDF = () => {
        const doc = new jsPDF();
        const tableData = imdatalogs.map((datalog) => [
            datalog.mTm,
            datalog.wtr,
            datalog.tmp,
            datalog.prs,
            datalog.is_imputed ? "Yes" : "No",
            datalog.is_anomaly_corrected ? "Yes" : "No",
        ]);

        doc.text("Datalogs", 14, 10);
        doc.autoTable({
            head: [
                [
                    "Measurement Time",
                    "Water Level",
                    "Temperature",
                    "Pressure",
                    "Is Imputed?",
                    "Is Anomaly Corrected?",
                ],
            ],
            body: tableData,
        });

        doc.save("datalogs.pdf");
    };

    const getImDatalogs = async (wellId) => {
        fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_last/${wellId}`)
            .then((res) => res.json())
            .then((newImdatalogs) => {
                setimDatalogs(newImdatalogs);
                setoriginalData(newImdatalogs);
                return newImdatalogs;
            })
            .catch((err) => console.error(err));
    };

    const handleDoForecast = async () => {
        if (!selectedMarker) return;

        setIsLoading(true);

        if (!startDate || !endDate) {
            alert("Please select valid dates.");
            setIsLoading(false);
            return;
        }

        if (startDate > endDate) {
            alert("Start date cannot be after end date.");
            setIsLoading(false);
            return;
        }

        try {
            // First merge data based on preferences
            const mergedData = await mergeDataBasedOnPreferences();

            if (!mergedData || mergedData.length === 0) {
                throw new Error("No data available for forecasting");
            }

            // const requestBody = {
            //     wellId: selectedMarker.wellId,
            //     weight_lstm: parseFloat(weights.weight_lstm),
            //     weight_bilstm: parseFloat(weights.weight_bilstm),
            //     weight_arima: parseFloat(weights.weight_arima),
            //     weight_sarima: parseFloat(weights.weight_sarima),
            //     start_date: startDate,
            //     end_date: endDate,
            //     period: parseInt(weights.period),
            //     selectedVersion: selectedVersion
            // };

            const requestBody = {
                wellId: selectedMarker.wellId,
                data: mergedData,
                weight_lstm: parseFloat(weights.weight_lstm),
                weight_bilstm: parseFloat(weights.weight_bilstm),
                weight_arima: parseFloat(weights.weight_arima),
                weight_sarima: parseFloat(weights.weight_sarima),
                start_date: startDate,
                end_date: endDate,
                period: parseInt(weights.period)
            };

            const response = await fetch("https://warpo-dashboard.cse.buet.ac.bd/api/api/get-forecast", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(requestBody)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || `Forecasting request failed with status ${response.status}`);
            }

            const forecastedResponse = await response.json();
            const forecastArray = forecastedResponse.forecasted_data?.data?.datalogs;

            if (!forecastArray || !Array.isArray(forecastArray)) {
                throw new Error("Forecasted datalogs not found or in wrong format");
            }

            const end = new Date(endDate);

            // Prepare displayed data with both original and forecasted values
            const processedForecast = forecastArray.map(item => {
                const date = new Date(item.mTm);
                const isForecast = date > end;

                // Find the original entry for the timestamp
                const originalEntry = mergedData.find(d =>
                    new Date(d.mTm).getTime() === date.getTime()
                );

                return {
                    mTm: item.mTm,
                    // For dates after endDate, store forecasted value in forecasted_wtr
                    forecasted_wtr: isForecast ? item.wtr : null,
                    // For dates before or equal to endDate, use the original value
                    wtr: !isForecast ? item.wtr : null,
                    // Preserve imputation and anomaly correction flags for proper dot coloring
                    is_imputed: originalEntry?.is_imputed || false,
                    is_anomaly_corrected: originalEntry?.is_anomaly_corrected || false
                };
            });

            console.log("Processed forecast data:", processedForecast);

            setIsForecasted(true);
            setimDatalogs(processedForecast);
            setIsFcModalOpen(true);
            alert("Forecasting completed successfully.");

        } catch (err) {
            console.error("Error during forecasting:", err);
            alert(`Forecasting failed: ${err.message}`);
        } finally {
            setIsLoading(false);  // This ensures loading state is always cleared
        }
    };


    const [isLoading, setIsLoading] = useState(false);

    if (isLoading) {
        return (
            <Modal
                open={isLoading}
                onClose={() => setIsLoading(false)}
                className="loading-modal"
            >
                <div className="loading-content">
                    <CircularProgress color="primary" />
                    <Typography
                        variant="h6"
                        style={{ marginTop: "20px", color: "#333333" }}
                    >
                        Working, Please Wait...
                    </Typography>
                    <div className="progress-bar">
                        <div className="progress" style={{ width: `${progress}%` }}></div>
                    </div>
                </div>
            </Modal>
        );
    }

    const parsedEndDate = new Date(endDate);

    const closestDate = [...filteredDataImDatalogs]
    .map(d => new Date(d.mTm))
    .filter(date => date <= parsedEndDate)
    .sort((a, b) => b - a)[0];

    const formatDateToLocalISO = (date) => {
        const tzOffset = date.getTimezoneOffset() * 60000; // in ms
        const localISOTime = new Date(date - tzOffset).toISOString().slice(0, 19);
        return localISOTime;
    };

    const closestDateStr = closestDate ? formatDateToLocalISO(closestDate) : null;
   

    return (
        <div className="modal">
            <div className="modal-overlay" />
            <div className="modal-row">
                <div className="modal-content left-content">
                    <div className="input-group">
                        <div className="left-content-wrapper" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0px" }}>
                                <div className="forecast-header" style={{marginRight: "20px"}}>
                                <h2 style={{ marginBottom: "0px", marginTop: '0px', color: "red" }}>Data Forecasting using Groundwater Level Data</h2>
                                </div>
                                <div className="multiple-col-forecast">
                                <button
                                    variant="contained"
                                    onClick={handleMultiColForecast}
                                    style={{
                                    height: "60px",
                                    backgroundColor: "#ff1111",
                                    color: "white",
                                    textTransform: "none",
                                    fontSize: "20px",
                                    width: "250px"
                                    }}
                                >
                                    Data Forecasting using Secondary Data
                                </button>
                                </div>
                            </div>

                            {/* First block: Well name and location (2 lines) */}
                            <div className="well-info-container" style={{ textAlign: "center", marginTop: "0px", marginBottom: "-10px" }}>
                                {/* <h2 style={{ marginBottom: "5px", color: "#85126e", fontSize: "32px", fontWeight: "bold" }}>Data Forecasting</h2>
                                <h3 style={{ marginBottom: "20px", color: "#85126e", fontSize: "16px", fontWeight: "normal" }}>
                                    (with Imputed/Anomaly Corrected Data)
                                </h3> */}
                                <h2 style={{ marginBottom: "0px", marginTop: "-10px", color: "#333", fontSize: "24px" }}>{selectedMarker.wellId}</h2>
                                <p style={{ margin: "0", color: "#555", fontSize: "16px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} />
                                    {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
                                </p>
                            </div>
                            <div className="date-range-display" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <p style={{ marginTop: "-10px", fontSize: "16px", color: "#333", textAlign: "center" }}>
                                    <strong>Earliest Date:</strong> {earliestDate ? new Date(earliestDate).toLocaleDateString() : 'Loading...'}&nbsp;&nbsp;|&nbsp;&nbsp;
                                    <strong>Latest Date:</strong> {latestDate ? new Date(latestDate).toLocaleDateString() : 'Loading...'}
                                </p>
                            </div>
                        </div>
                    </div>


                    <div className="date-range-container" style={{ marginTop: "-10px" }}>
                        <div className="date-inputs" style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-end" }}>
                            <div className="date-field-container">
                                <label htmlFor="start-date" style={{ color: "#85126e", marginBottom: "5px", display: "block" }}>Start Date</label>
                                <input
                                    id="start-date"
                                    type="date"
                                    value={startDate}
                                    onChange={handleStartDateChange}
                                    className="date-input-field"
                                    style={{
                                        padding: "10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        color: "#85126e",
                                        width: "200px"
                                    }}
                                />
                            </div>
                            <div className="date-field-container">
                                <label htmlFor="end-date" style={{ color: "#85126e", marginBottom: "5px", display: "block" }}>End Date</label>
                                <input
                                    id="end-date"
                                    type="date"
                                    value={endDate}
                                    onChange={handleEndDateChange}
                                    className="date-input-field"
                                    style={{
                                        padding: "10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        color: "#85126e",
                                        width: "200px"
                                    }}
                                />
                            </div>
                        </div>

                        {/* Add Missing Data Rate Button centered */}
                        <div style={{ marginTop: "-20px", marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                            <Button
                                variant="contained"
                                onClick={fetchMissingDataRate}
                                style={{
                                    height: "40px",
                                    backgroundColor: "#4a148c",
                                    color: "white",
                                    textTransform: "none",
                                    fontSize: "16px",
                                    width: "250px"
                                }}
                            >
                                Show Missing Data Rate
                            </Button>
                        </div>

                        {/* Static Missing Data Rate Message */}
                        {showMissingRate && missingDataRate !== null && (
                            <div
                                style={{
                                    marginTop: "-30px", /* Reduced margin */
                                    marginBottom: "20px", /* Reduced margin */
                                    padding: "6px", /* Reduced padding */
                                    backgroundColor: "#f0f0f0",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    width: "90%",
                                    textAlign: "center"
                                }}
                            >
                                <p style={{ margin: 0, fontWeight: "bold", textAlign: "center", fontSize: "14px" }}>
                                    Missing Data Rate for Selected Period: <span style={{ color: "#d32f2f" }}>{missingDataRate.toFixed(2)}%</span>
                                </p>
                            </div>
                        )}
                    </div>



                    <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", gap: "10px", width: "100%", marginTop: "-20px" }}>
                        <div className="missing-container">
                            <h3 style={{ margin: "5px 0", fontSize: "15px" }}>Artificial Missing Rate:</h3>
                            <TextField
                                variant="outlined"
                                value={Rate}
                                onChange={handleRateChange}
                                className="rate-text-field"
                                InputLabelProps={{
                                    style: { color: "#85126e" },
                                }}
                                InputProps={{
                                    style: { color: "#85126e" },
                                }}
                                sx={{ height: "48px" }}
                            />
                        </div>
                        <div className="toggle-group-container">
                            <h3 style={{ margin: "5px 0", fontSize: "15px" }}>Season-Based Type:</h3>
                            <ToggleButtonGroup
                                value={option}
                                exclusive
                                onChange={handleOption}
                                aria-label="Choose one"
                                className="toggle-button-group"
                                sx={{
                                    height: "48px",
                                    width: "230px",
                                    display: "flex"
                                }}
                            >
                                <ToggleButton
                                    value="overall"
                                    aria-label="overall"
                                    sx={{
                                        flex: "1 1 50%",
                                        borderRadius: option === "overall" ? undefined : "4px 0 0 4px"
                                    }}
                                >
                                    Overall
                                </ToggleButton>
                                <ToggleButton
                                    value="peak"
                                    aria-label="peak"
                                    sx={{
                                        flex: "1 1 50%",
                                        borderRadius: option === "peak" ? undefined : "0 4px 4px 0"
                                    }}
                                >
                                    Peak - Off-Peak
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                    </div>

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        margin: "10px 0" /* Reduced margin */
                    }}>
                        <ModelRankingTable
                            selectedMarker={selectedMarker}
                            Rate={Rate}
                            option={option}
                            startDate={startDate}
                            endDate={endDate}
                            imp_or_anom="anom"
                        />
                    </div>


                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginLeft: '30px', marginRight: '30px' }}>
                        {/* Imputation Version Selection */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FormControl variant="outlined" style={{ width: '600px' }}>
                                <InputLabel id="imp-version-label">Select Version of Imputation</InputLabel>
                                <Select
                                    labelId="imp-version-label"
                                    value={selectedVersion}
                                    onChange={handleVersionChange}
                                    label="Select Version of Imputation"
                                    fullWidth
                                >
                                    <MenuItem value={0}>
                                        Version 0 - Original Data (No Imputation)
                                    </MenuItem>
                                    {versions.map((version) => (
                                        <MenuItem key={version.version_number} value={version.version_number}>
                                            {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd-MM-yyyy HH:mm:ss')}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleDetailsButtonClick}
                                disabled={selectedVersion === 0}
                            >
                                Details
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleClearImputationVersion}
                                disabled={selectedVersion === 0}
                            >
                                Clear
                            </Button>
                        </div>

                        {/* Anomaly Correction Version Selection */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FormControl variant="outlined" style={{ width: '600px' }}>
                                <InputLabel id="anom-version-label">Select Version of Anomaly Correction</InputLabel>
                                <Select
                                    labelId="anom-version-label"
                                    value={selectedVersionAnom}
                                    onChange={handleVersionChangeAnom}
                                    label="Select Version of Anomaly Correction"
                                    fullWidth
                                >
                                    <MenuItem value="0">
                                        Version 0 - Original Data (No Anomaly Correction)
                                    </MenuItem>
                                    {versionsanom.map((version) => (
                                        <MenuItem key={version.version_number} value={version.version_number}>
                                            {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd-MM-yyyy HH:mm:ss')}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleDetailsButtonClickAnom}
                                disabled={selectedVersionAnom === "0"}
                            >
                                Details
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={handleClearAnomalyVersion}
                                disabled={selectedVersionAnom === "0"}
                            >
                                Clear
                            </Button>
                        </div>


                        {/* Data Preference Dropdown - NEW */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0px', marginBottom: '15px' }}>
                            <FormControl variant="outlined" style={{ width: '300px' }}>
                                <InputLabel id="data-preference-label">Data Merge Preference</InputLabel>
                                <Select
                                    labelId="data-preference-label"
                                    value={dataPreference}
                                    onChange={handleDataPreferenceChange}
                                    label="Data Merge Preference"
                                    fullWidth
                                >
                                    <MenuItem value="imputation">Imputation over Anomaly Correction</MenuItem>
                                    <MenuItem value="anomaly">Anomaly Correction over Imputation</MenuItem>
                                </Select>
                            </FormControl>
                            <Typography variant="caption" style={{ marginTop: '0px', textAlign: 'center', color: '#666' }}>
                                When merging data, the selected type will take precedence over the other
                            </Typography>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '-20px', marginBottom: '-10px' }}>
                            <Button
                                variant="contained"
                                onClick={mergeDataBasedOnPreferences}
                                className="button submit-button"
                                style={{
                                    height: "40px",
                                    width: "170px",
                                    textTransform: "none",
                                    fontSize: "16px",
                                    backgroundColor: "#2e7d32"
                                }}
                            >
                                Merge Data
                            </Button>
                        </div>
                    </div>

                    <Modal open={isModalOpen} onClose={handleCloseModal}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '53%',
                                left: '74%',
                                transform: 'translate(-50%, -50%)',
                                backgroundColor: 'cyan',
                                color: 'black',
                                padding: '20px',
                                borderRadius: '8px',
                                minWidth: '400px',
                            }}
                        >
                            <Typography variant="h6">Version Details</Typography>

                            {versionDetails ? (
                                <div>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Well ID:</strong> {versionDetails.wellId}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Version Number:</strong> {versionDetails.version_number}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Update Time:</strong> {formatDate(versionDetails.update_time)}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}>
                                        <strong>Imputation Date Range:</strong>  {formatDate(versionDetails.start_date, 'd MMM yyyy')} to{' '}
                                        {formatDate(versionDetails.end_date, 'd MMM yyyy')}
                                    </p>

                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Name:</strong> {versionDetails.name}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Designation:</strong> {versionDetails.designation}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Email:</strong> {versionDetails.email}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Contact No:</strong> {versionDetails.contact_no}</p>
                                    <p style={{ color: 'black', fontSize: '16px' }}><strong>Comments:</strong> {versionDetails.comments}</p>
                                </div>
                            ) : (
                                <p>Loading...</p>
                            )}

                            {/* Close Button */}
                            <Button
                                onClick={handleCloseModal}
                                style={{ backgroundColor: 'red', color: 'white', width: '100px' }}
                            >
                                Close
                            </Button>
                        </div>
                    </Modal>

                    <div className="model-weights" style={{ marginBottom: '-10px' }}>
                        <h3>Forecasting Period (in Months)</h3>
                        <TextField
                            label="Period"
                            variant="outlined"
                            name="period"
                            value={weights.period}
                            onChange={handleWeightChange}
                            className="weight-input"
                        />
                    </div>

                    <div className="model-weights">
                        <h3>Model Weights</h3>
                        <TextField
                            label="LSTM"
                            variant="outlined"
                            name="weight_lstm"
                            value={weights.weight_lstm}
                            onChange={handleWeightChange}
                            className="weight-input"
                        />
                        <TextField
                            label="BiLSTM"
                            variant="outlined"
                            name="weight_bilstm"
                            value={weights.weight_bilstm}
                            onChange={handleWeightChange}
                            className="weight-input"
                        />
                        <TextField
                            label="ARIMA"
                            variant="outlined"
                            name="weight_arima"
                            value={weights.weight_arima}
                            onChange={handleWeightChange}
                            className="weight-input"
                        />
                        <TextField
                            label="SARIMA"
                            variant="outlined"
                            name="weight_sarima"
                            value={weights.weight_sarima}
                            onChange={handleWeightChange}
                            className="weight-input"
                        />
                    </div>

                    <div className="action-buttons" style={{ display: "flex", justifyContent: "center", gap: "20px", marginTop: "0px" }}>
                        <Button
                            variant="contained"
                            onClick={handleClear}
                            className="button clear-button"
                            style={{
                                height: "40px",
                                width: "120px",
                                textTransform: "none",
                                fontSize: "16px"
                            }}
                        >
                            Clear
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleDoForecast}
                            className="button submit-button"
                            style={{
                                height: "40px",
                                width: "170px",
                                textTransform: "none",
                                fontSize: "16px"
                            }}
                        >
                            Get Forecast
                        </Button>
                    </div>
                </div>

                <div className="modal-content right-content">
                    <div style={{ marginBottom: '5px' }}>
                        <div className="button-group" style={{ marginBottom: '5px' }}>
                            <Button
                                variant="contained"
                                onClick={imdownloadAsCSV}
                                className="blue-button"
                            >
                                Download as CSV
                            </Button>
                            <Button
                                variant="contained"
                                onClick={imdownloadAsPDF}
                                className="green-button"
                            >
                                Download as PDF
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => setHelpOpen(true)}
                            >
                                Help
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleCloseFcModal}
                                className="red-button"
                            >
                                Close Window
                            </Button>
                        </div>

                        <h2 style={{ margin: '0 0 3px 0' }}>Datalog for {selectedMarker.wellId}</h2>
                    </div>

                    {/* Help Modal */}
                    <HelpModal
                        open={helpOpen}
                        handleClose={() => setHelpOpen(false)}
                    />
                    <div style={{ flex: 1, overflowY: 'auto', padding: '10px', marginLeft: '30px', marginRight: '30px' }}>
                        {/* Graph section with original design but reduced spacing */}
                        <div className="graph-container" style={{ marginBottom: '5px' }}>
                            <div className="button-group" style={{ marginBottom: '3px' }}>
                                <Button
                                    variant="contained"
                                    onClick={resetZoomImDatalogs}
                                    className="zoom-button"
                                >
                                    Reset Zoom
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={handleDownload}
                                    className="zoom-button"
                                >
                                    Save Image
                                </Button>
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    width: "100%",
                                    marginBottom: "3px"
                                }}
                            >
                                <Slider
                                    value={zoomLevelImDatalogs}
                                    onChange={handleZoomImDatalogs}
                                    aria-labelledby="zoom-slider"
                                    min={0}
                                    max={100}
                                    step={5}
                                    valueLabelDisplay="auto"
                                    style={{ flex: 1 }}
                                />
                                <h3 style={{ minWidth: "50px", margin: 0 }}>
                                    {zoomLevelImDatalogs}%
                                </h3>
                            </div>

                            <div className="filter-container" style={{ marginBottom: "3px" }}>
                                <h3 className="filter-label">Filter Data: </h3>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    className="filter-dropdown"
                                >
                                    <InputLabel>Data Points</InputLabel>
                                    <Select
                                        value={dataLimitImDatalogs}
                                        onChange={handleDataLimitChangeImDatalogs}
                                        label="Data Points"
                                    >
                                        <MenuItem value={10}>Last 10</MenuItem>
                                        <MenuItem value={50}>Last 50</MenuItem>
                                        <MenuItem value={100}>Last 100</MenuItem>
                                        <MenuItem value={visibleDataImDatalogs.length}>
                                            All
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div ref={chartRef}>
                                <ResponsiveContainer width="100%" height={200}>
                                    <LineChart
                                        data={filteredDataImDatalogs.length > 0 ? filteredDataImDatalogs : []}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis
                                            dataKey="mTm"
                                            tickFormatter={(tick) =>
                                                new Date(tick).toLocaleDateString()
                                            }
                                            label={{
                                                value: "Measurement Time",
                                                position: "insideBottom",
                                                offset: 0,
                                                dy: 3,
                                            }}
                                        />
                                        <YAxis
                                            domain={[0, 12]}
                                            label={{
                                                value: "Water Level (meter)",
                                                angle: -90,
                                                position: "insideLeft",
                                                dy: 60,
                                            }}
                                        />
                                        <Tooltip
                                            contentStyle={{ color: "#333" }}
                                            labelFormatter={(value) =>
                                                `Time: ${formatDate(value)}`
                                            }
                                            formatter={(value, name) => {
                                                if (name === "forecasted_wtr" && value !== null) {
                                                    return [`${value} (Forecast)`, "Forecasted"];
                                                }
                                                return [`${value}`, name === "wtr" ? "Water Level" : name];
                                            }}
                                        />

                                        {/* Original wtr line */}
                                        <Line
                                            type="monotone"
                                            dataKey="wtr"
                                            stroke="#000000"
                                            strokeWidth={2}
                                            dot={CustomDot('wtr')}
                                            name="Water Level"
                                        />

                                        {/* forecasted wtr line */}
                                        {isForecasted && (
                                            <Line
                                                type="monotone"
                                                dataKey="forecasted_wtr"
                                                stroke="#FF8C00"
                                                strokeWidth={2}
                                                strokeDasharray="5 5"
                                                dot={CustomDot('forecasted_wtr')}
                                                name="Forecasted Water Level"
                                                isAnimationActive={false}
                                            />
                                        )}

                                        {/* Vertical Reference Line at endDate */}
                                        {isForecasted && endDate && (
                                            <>
                                                {console.log("Sample mTm:", filteredDataImDatalogs[0]?.mTm)}
                                                {console.log("End Date with ISO String =", new Date(endDate).toISOString().slice(0, 19))}
                                                {console.log("closestDate with ISO String =", closestDateStr)}
                                                <ReferenceLine
                                                    x={closestDateStr}
                                                    stroke="orange"
                                                    strokeWidth={2}
                                                    strokeDasharray="3 3"
                                                    label={{
                                                        value: "Forecast Start",
                                                        position: "insideTopLeft",
                                                        fill: "#FF8C00",
                                                        fontSize: 12
                                                    }}
                                                />
                                            </>
                                            
                                        )}

                                        <Brush
                                            dataKey="mTm"
                                            height={30}
                                            stroke="#8884d8"
                                            y={175}
                                            tickFormatter={(tick) =>
                                                new Date(tick).toLocaleString()
                                            }
                                        />

                                        <Legend
                                            verticalAlign="top"
                                            height={36}
                                            wrapperStyle={{
                                                fontSize: "12px",
                                            }}
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>

                        </div>

                        <p style={{ margin: '2px 0' }}>
                            Click on the cell to sort it ASC <FaArrowUp /> or DESC <FaArrowDown />
                        </p>

                        {/* Table section - keeping original design with more space */}
                        <TableContainer
                            component={Paper}
                            sx={{
                                backgroundColor: "#000000",
                                padding: "10px",
                                borderRadius: "8px",
                            }}
                        >
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead sx={{ backgroundColor: "#ffffff" }}>
                                    <TableRow>
                                        <TableCell>
                                            <TableSortLabel
                                                active={sortConfig.mTm.direction !== "asc"}
                                                direction={sortConfig.mTm.direction}
                                                onClick={() => handleSort("mTm")}
                                            >
                                                Measurement Time
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell>
                                            Water Level
                                        </TableCell>
                                        {isForecasted && (
                                            <TableCell>
                                                Forecasted Water Level
                                            </TableCell>
                                        )}
                                        <TableCell>
                                            Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {sortedImDatalogs.map((datalog, index) => {
                                        const isFuture = datalog.mTm && endDate ? new Date(datalog.mTm) > new Date(endDate) : false;
                                        const status = datalog.is_imputed
                                            ? "Imputed"
                                            : datalog.is_anomaly_corrected
                                                ? "Anomaly Corrected"
                                                : "-";

                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    backgroundColor: isFuture && isForecasted ? "#052d0a" : "#1a1a1a",
                                                    "&:nth-of-type(odd)": {
                                                        backgroundColor: isFuture && isForecasted ? "#052d0a" : "#262626",
                                                    },
                                                }}
                                            >
                                                <TableCell sx={{ color: "#ffffff" }}>
                                                    {formatDate(datalog.mTm)}
                                                </TableCell>
                                                <TableCell sx={{ color: "#ffffff" }}>
                                                    {datalog.wtr || "-"}
                                                </TableCell>
                                                {isForecasted && (
                                                    <TableCell sx={{ color: "#ffffff" }}>
                                                        {datalog.forecasted_wtr || "-"}
                                                    </TableCell>
                                                )}
                                                <TableCell sx={{ color: "#ffffff" }}>
                                                    {status}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                </div>

                {/* Confirmation Dialog */}
                <Modal
                    open={confirmDialogOpen}
                    onClose={handleConfirmDialogCancel}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            backgroundColor: 'white',
                            padding: '20px',
                            borderRadius: '8px',
                            boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                            width: '400px',
                        }}
                    >
                        <Typography variant="h6" style={{ marginBottom: '20px', color: 'black' }}>
                            Confirm Action
                        </Typography>
                        <Typography variant="body1" style={{ marginBottom: '20px', color: 'black' }}>
                            {confirmDialogMessage}
                        </Typography>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={handleConfirmDialogCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleConfirmDialogConfirm}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default Forecastlog;